export default '/build/7bbfa98d.svg'